module.exports = __webpack_public_path__ + "static/media/Kitchen.98afe72c.png";